module.exports = __webpack_public_path__ + "img/xbank-view-small.e50dcce1.png";